<template>
    <div>
        <van-nav-bar
                title="实名认证"
                left-arrow
                @click-left="onClickLeft"
        />
        <div style="display: flex;flex-direction: column;margin: 10px;">
            <div style="position: relative;margin: 20px;" @click="chooseFontImage">
                <img v-if="frontImage" :src="frontImage" style="width: 100%">
                <template v-else>
                    <img src="../assets/id-placeholder.png" style="width: 100%">
                    <div style="position: absolute;bottom: 0;top: 0;left: 0;right: 0;border-radius: 10px;border: solid 1px #ebedf0 ;display: flex;flex-direction:column;align-items: center;justify-content: center">
                        <van-icon size="40" name="photo-o" />
                        <span>点击上传身份证正面</span>
                    </div>
                </template>
            </div>
            <div style="position: relative;margin: 20px;" @click="chooseBackImage">

                <img v-if="backImage" :src="backImage" style="width: 100%">
                <template v-else>
                    <img src="../assets/id-placeholder.png" style="width: 100%">
                    <div style="position: absolute;bottom: 0;top: 0;left: 0;right: 0;border-radius: 10px;border: solid 1px #ebedf0;display: flex;flex-direction:column;align-items: center;justify-content: center">
                        <van-icon size="40" name="photo-o" />
                        <span>点击上传身份证反面</span>
                    </div>
                </template>

            </div>
           <van-button type="info" @click="check">认证</van-button>
        </div>
    </div>
</template>
<script>
  import axios from '../common/axios';
  import {responseCodes,consultReplyTypes,userTypes,consultStatus} from '../common/const'
  import {Toast} from 'vant'
  var wx = require('weixin-js-sdk');
  export default {
    name: "RealName",
    data() {
      return {
        name: this.$store.state.user.name,
        phone:this.$store.state.user.phone,
        wxJsapiSignature:{},
        frontImage:undefined,
        backImage:undefined
      };
    },
    mounted(){
        this.getWxJsapiSignature()
    },
    methods: {
      onClickLeft() {
        this.$router.back();
      },
      async getWxJsapiSignature() {
        let response = await axios.get('/fyserve/user/getJsapiTicket')
        let data = response.data;
        if (data.code === responseCodes.success) {
          this.wxJsapiSignature = data.data;
          this.wxJsapiSignature.jsApiList = ['chooseImage', 'getLocalImgData']
          this.wxJsapiSignature.debug=  true
          this.wxJsapiConfig();
        } else {
          Toast.fail("请求微信签名失败")
          this.$router.back();
        }
      },
      wxJsapiConfig() {
        console.info("config")
        wx.config(this.wxJsapiSignature);
        this.$store.commit("showOverlay")
        wx.ready(()=>{
          console.info("succeed")
          this.$store.commit("hideOverlay")
        });
        wx.error(()=>{
          console.info("failed")
          this.$store.commit("hideOverlay")
          Toast.fail("微信工具配置失败");
          this.$router.back();
        })
      },
      chooseFontImage() {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'], // 指定是原图还是压缩图，默认都有
          sourceType: ['album', 'camera'], // 指定来源是相册还是相机，默认都有
          success:  (res) =>{
            console.info('camera')
            console.info(res)
            wx.getLocalImgData({
              localId: res.localIds[0],//图片的本地ID
              success:  (res)=> {
                console.info('local')
                console.info(res)
                this.frontImage  = res.localData;//base64
              }
            });
             // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          }
        });

      },
      chooseBackImage() {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: [ 'compressed'], // 指定是原图还是压缩图，默认都有
          sourceType: ['album', 'camera'], // 指定来源是相册还是相机，默认都有
          success:  (res)=> {
            wx.getLocalImgData({
              localId: res.localIds[0],//图片的本地ID
              success:  (res) =>{
                this.backImage  = res.localData;//base64
              }
            });
          }
        });
      },
      async check(){
        wx.previewImage({
          current: 'https://jtfy-1301652109.cos.ap-beijing.myqcloud.com/doc/%E6%B3%95%E5%BE%8B%E6%8F%B4%E5%8A%A9%E7%94%B3%E8%AF%B7%E8%A1%A8-%E6%A8%A1%E7%89%88.jpg',//当前显示图片的http链接，我这边是把图片转成了base64
          urls: ['https://jtfy-1301652109.cos.ap-beijing.myqcloud.com/doc/%E6%B3%95%E5%BE%8B%E6%8F%B4%E5%8A%A9%E7%94%B3%E8%AF%B7%E8%A1%A8-%E6%A8%A1%E7%89%88.jpg'] //需要预览的图片http链接列表
        })
      },



    }
  }
</script>

<style scoped>

</style>